// import "./LayoutStyle.scss";
import { IJSLComponent, IJSLVNode } from "jsl-render";
import { mapUrl } from "../../helper/mapUrl";

export class LayoutComponent implements IJSLComponent {

    public constructor(private bodyComponent: IJSLVNode | IJSLComponent) {}

    public render(): IJSLVNode {
        return <div style="padding-top:5rem;padding-bottom: 1px;">
            <div class="nav-header"><img src={mapUrl("Content/images/logo.png")} style="height:3.1rem" /></div>
            {this.bodyComponent}
            <div class="wave"></div>
            <div class="wave-red"></div>
        </div>;
    }
}
